import AnnotatedImage from './AnnotatedImage'
export default AnnotatedImage